import type { TextareaProps } from '@gto/ui/textarea'
import { Textarea } from '@gto/ui/textarea'

import type { FieldShellProps } from './field-shell'
import { FieldShell } from './field-shell'

type TextareaFieldProps = FieldShellProps & {
  textareaClassName?: string
} & Omit<TextareaProps, 'className'>

/** DS replacement for MUI TextField multiline. */
export const TextareaField = ({
  label,
  error,
  helperText,
  disabled,
  required,
  className,
  textareaClassName,
  size = 'small',
  ...textarea
}: TextareaFieldProps) => (
  <FieldShell
    className={className}
    disabled={disabled}
    error={error}
    helperText={helperText}
    label={label}
    required={required}
    control={
      <Textarea
        aria-required={required === true ? true : undefined}
        className={textareaClassName}
        disabled={disabled}
        size={size}
        {...textarea}
      />
    }
  />
)
